import React from 'react';
import styled from 'styled-components';
import { Button, Row, Col, Select, Descriptions, Badge, Typography } from 'antd';
import { chain, isEmpty, pick, get, clone } from 'lodash';
import { object, string } from 'yup';
import consts from "../consts";
import FloatLabelInputComponent from "./common/FloatLabelInputComponent";
import LoadingAndValidateComponent from './common/LoadingAndValidateComponent';
import utils from '../common/utils';


const { Text } = Typography;

const labelstyle = {
  boxSizing: "border-box",
  minWidth: 0,
  fontSize: '14px',
  color: '#76808f',
  fontWeight: '400',
  textAlign: 'left',
  paddingTop: '4px',
  paddingBottom: '4px',
  backgroundColor: 'inherit',
};

const { Option } = Select

const InputWrapper = styled.div`
    margin: 0 10px;
    
    & > * {
        margin-top: 40px
    }
    &>.p-abs.no-wrap {
        margin-top: 0 !important;
    }
    & > .ant-select-selector{
        width: 70%;
    }

    &>.ant-select > .ant-select-selector{
        height: 36px;
    }
    & > .select-title{
        margin-top: 40px;
        margin-bottom:0px;
    }
`

const InfoWrapper = styled.div`
    margin: 35px;
`

const Container = styled.div`
    background-color: white;
    padding-bottom: 20px;
`
const Center = styled.div`
    text-align: center;
    margin-top: 40px
`
class TransactionVerify extends LoadingAndValidateComponent {
  constructor(props) {
    super(props)
    this.state = {
      ...this.state,
      params: {
        txhash: '',
        address: '',
        chain: 'ETH',
        userInfo: {},
      },
      network: '',
      
    }
    this.acceptParams = {}
  }

  onClick = async () => {
    const isValid = await this.validate();
    if (isValid) {
      this.setState({ network: this.props.coins[this.state.params.chain].network })
      this.props.verifyTransaction({ ...this.state.params }, () => { this.acceptParams = clone(this.state.params)
      console.log(this.acceptParams)})
      this.props.fetchUserByAddress({ address: this.state.params.address }, (userInfo) => this.setState({ userInfo }));
    }
  }

  async validate() {
    let address = string().required().min(26).label('Địa chỉ');

    if (this.props.coins[this.state.params.chain].type === consts.ETH) {
      address = address.test('isValidAddress', 'Địa chỉ không hợp lệ',
        (value) => `${get(this.props, `mapUserBalance.${this.props.coins[this.state.params.chain].symbol}.blockchain_address`, '')}`.toLowerCase() !== `${value}`.toLowerCase())
        .test('isValidEth', 'Địa chỉ không hợp lệ', (value) => utils.isAddress(value));
    }

    let txhash = string().required("Mã hash không được bỏ trống").max(66).label('Mã hash');

    this.yupValidate = object().shape({
      address,
      txhash,
    });
    return super.validate();
  }


  acceptTransaction = () => {
    this.props.acceptTransaction({ ...this.acceptParams });
  }

  render() {
    const { params, errors } = this.state;
    const {
        pubkey,
        email,
        avatar,
        phone,
        last_login,
        registration_date,
        rootkey,
    } = this.state.userInfo || {};

    const {
      created_at,
      address,
      amount,
      coin,
    } = this.props.verifyInfo || {};
    return (
      <div className="withdrawalHistory">
        <h3>Kiểm tra giao dịch</h3>
        <Container>
          <Row>
            <Col span={12}>
              <InputWrapper>
                <div className='select-title'>Chain của giao dịch</div>
                <Select
                  style={{ width: '70%', height: '36px' }}
                  filterOption={false}
                  listItemHeight={30}
                  defaultValue='ETH'
                  onChange={(value) => { this.setState({ params: { ...params, chain: value } }) }}
                >
                  {chain(pick(this.props.coins, ['ETH', 'BTC', 'TOMO'])).values()
                    .filter(({ symbol, name }) => `${symbol}${name}`.toLowerCase())
                    .map((coin) => {
                      return <Option key={coin.symbol} value={coin.symbol}>
                        <div style={{
                          display: 'block',
                          backgroundRepeat: 'no-repeat',
                          backgroundSize: 'contain',
                          height: '24px',
                          width: '24px',
                          backgroundImage: `url("${coin?.icon_image || ''}")`,
                          float: "left"
                        }} className="mr-small mt-ex-small" />
                        <div className="ln-normal pr-large">
                          {coin.symbol} {coin.name}
                        </div>
                      </Option>
                    }).value()}
                </Select>
                <FloatLabelInputComponent
                  label={`Mã hash của giao dịch:`}
                  className='default-input'
                  labelstyle={labelstyle}
                  transform="scale(1) translate(0, -50%)"
                  value={params.txhash}
                  overrideFocus={this.clearErrors}
                  onChange={({ target }) => this.setState({ params: { ...params, txhash: target.value.trim() } })}
                />
                <div className=" p-abs no-wrap">
                  <Text type='danger'>{utils.upperCaseFirst(errors.txhash || '')}</Text>
                </div>
                <FloatLabelInputComponent
                  label={`Địa chỉ ví nhận tiền:`}
                  className='default-input'
                  labelstyle={labelstyle}
                  transform="scale(1) translate(0, -50%)"
                  value={params.address}
                  overrideFocus={this.clearErrors}
                  onChange={({ target }) => this.setState({ params: { ...params, address: target.value.trim() } })}
                />
                <div className=" p-abs no-wrap">
                  <Text type='danger'>{utils.upperCaseFirst(errors.address || '')}</Text>
                </div>
              </InputWrapper>
              <Center>
                  <Button type='primary' onClick={this.onClick}>Tra cứu</Button>
                </Center>
            </Col>
            <Col span={12} >
              {!isEmpty(this.props.verifyInfo) && (
                <InfoWrapper>
                  <Descriptions title={<Badge status="processing" text="Thông tin giao dịch" />}>
                    <Descriptions.Item label="Địa chỉ nhận" span={3}>{address}</Descriptions.Item>
                    <Descriptions.Item label="Số lượng giao dịch">{amount} {coin}</Descriptions.Item>
                    <Descriptions.Item span={2}
                      label="Thời gian giao dịch">{utils.formatTimeFromUnix(created_at, 'DD/MM/YY HH:mm:ss')}
                    </Descriptions.Item>
                    <Descriptions.Item label="Chi tiết giao dịch" span={3}>
                      <a href={`${this.props.coins[this.state.params.chain].transaction_explorer}/tx/${this.acceptParams.txhash}`} target="_blank">{`${this.props.coins[this.state.params.chain].transaction_explorer}/tx/${this.acceptParams.txhash}`}</a>
                    </Descriptions.Item>
                  </Descriptions>
                  <br />
                  <br />
                  <Center><Button type='primary' onClick={this.acceptTransaction}>Xác nhận chuyển tiền</Button></Center>
                </InfoWrapper>
              )}
            </Col>
          </Row>
        </Container>
        {!isEmpty(this.state.userInfo) && (
          <div className="p-medium bg-white mt-medium">
            <Descriptions title={<Badge status="processing" text="Thông tin người dùng" />}>
              <Descriptions.Item><img src={avatar} alt={avatar} style={{
                height: 88,
                width: 88,
                backgroundSize: 'cover'
              }} /></Descriptions.Item>
              <br />
              <br />
              <Descriptions.Item label="Pubkey" span={3}>{pubkey}</Descriptions.Item>
              <Descriptions.Item label="Số điện thoại">{phone}</Descriptions.Item>
              <Descriptions.Item
                label="Lần cuối đăng nhập">{utils.formatTimeFromUnix(last_login)}</Descriptions.Item>
              <Descriptions.Item
                label="Ngày đăng ký">{utils.formatTimeFromUnix(registration_date)}</Descriptions.Item>
              <Descriptions.Item label="Mã giới thiệu"><span className='ellipsis w-230' >{rootkey}</span></Descriptions.Item>
              <Descriptions.Item label="Email">{email}</Descriptions.Item>
            </Descriptions>

                </div>
            )}
        </div>
    )
  }
}

export default TransactionVerify
